import type { ActionButtonsProps } from 'redesign/components/organisms/action-buttons/types'
import type { Action } from 'redesign/components/organisms/action-wrapper/types'
import { EMPTY_ACTIONS } from '../constants'

export const getMainAndHiddenButtons = (actionItems: Action[]): ActionButtonsProps => {
  if (!actionItems.length) return EMPTY_ACTIONS

  const [mainAction, ...rest] = actionItems
  const primaryMainAction = { ...mainAction, variant: 'contained', color: 'primary' } as const

  if (actionItems.length <= 2) {
    return { mainActions: [primaryMainAction, ...rest] }
  }

  return { mainActions: [primaryMainAction], hiddenActions: rest }
}
